module.exports = __webpack_public_path__ + "img/horizontal_3_3_r_3.668b9453.png";